import React from 'react';
import Info from '../assets/images/Info-Blue.svg';

export default () => {
  return <img src={Info} alt="Information" />;
};
